import { inertia } from "@evento/svelte-inertia";
function link(node, options = {}) {
    if (options?.disabled) {
        return;
    }
    const href = node?.href ?? options?.href;
    if (href === "javascript:void(0)") {
        return;
    }
    if (isSamePageAnchor(href)) {
        return;
    }
    if ((node?.target && node.target.toLowerCase() === "_blank") ||
        (node?.rel && node.rel.toLowerCase() === "noopener")) {
        return;
    }
    return inertia(node, options);
}
function isSamePageAnchor(href) {
    const currentUrl = new URL(window.location.href);
    const targetUrl = new URL(href, window.location.href);
    // Ignorovat query parametry
    currentUrl.search = "";
    targetUrl.search = "";
    // Zkontrolovat, zda jsou protokol, host a cesta stejné
    const isSamePage = currentUrl.protocol === targetUrl.protocol &&
        currentUrl.host === targetUrl.host &&
        currentUrl.pathname === targetUrl.pathname;
    // Zkontrolovat, zda href obsahuje #anchor
    const hasAnchor = targetUrl.hash.length > 0;
    return isSamePage && hasAnchor;
}
export { link as default, link };
